
import SalesExpensesMSTImportLayoutPage from './SalesExpensesMSTImportLayoutPage';

export default SalesExpensesMSTImportLayoutPage;
